export interface Location {
  lat: number;
  lng: number;
  city: string;
  country: string;
}

export const montreal: Location = {
  lat: 45.5017,
  lng: -73.5673,
  city: 'montreal',
  country: 'canada',
};
export const bangkok: Location = {
  lat: 13.7563,
  lng: 100.5018,
  city: 'bangkok',
  country: 'thailand',
};
export const dortmund: Location = {
  lat: 51.5136,
  lng: 7.4653,
  city: 'dortmund',
  country: 'germany',
};
export const trier: Location = {
  lat: 49.7726,
  lng: 6.6333,
  city: 'Trier',
  country: 'germany',
};
export const zwentendorf: Location = {
  lat: 48.3499,
  lng: 15.8999,
  city: 'zwentendorf',
  country: 'austria',
};
export const sydney: Location = {
  lat: -33.8688,
  lng: 151.2093,
  city: 'sydney',
  country: 'australia',
};
export const thun: Location = {
  lat: 46.7511,
  lng: 7.6216,
  city: 'thun',
  country: 'switzerland',
};
